import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { useTranslation } from 'react-i18next'
import { upperFirstOnly } from 'utils/format'
import styles from './Filters.module.scss'
import { GradeDropdown } from 'components/common/performance-report/components/grade-dropdown'
import { StationSelector } from 'components/common/performance-report/components/station-selector'
import { StatusDropdown } from '../status-dropdown'
import moment from 'moment-timezone'
import { PeriodDropdown } from '../period-dropdown'
import { useStations } from 'components/common/hooks/useStations'

const cx = classNames.bind(styles)

const Filters = ({
  stationIds,
  setSelectedStation,
  fuelGradesItems,
  fuelGrades,
  setSelectedGrades,
  statuses,
  setSelectedStatuses,
  period,
  setSelectedPeriod,
}) => {
  const { t } = useTranslation(['translations'])
  const { stations } = useStations()

  return (
    <div className={cx('select-boxes')} data-testid="filters">
      <StationSelector
        stations={stations}
        value={stationIds}
        onValueChange={setSelectedStation}
        placeholder={upperFirstOnly(
          t('widgets.performanceReport.noStationsSelected')
        )}
        allStationsText={upperFirstOnly(
          t('widgets.performanceReport.allStationsSelected')
        )}
        maxHeight="228px"
        selectButtons={true}
        itemsLimit={null}
        allowGroups={true}
      />
      <GradeDropdown
        options={fuelGradesItems}
        value={fuelGrades}
        onValueChange={setSelectedGrades}
        enableIcon={false}
        dataTestId={'grades-dropdown'}
      />
      <PeriodDropdown
        period={period}
        onPeriodChange={setSelectedPeriod}
      />
      <StatusDropdown
        value={statuses}
        onValueChange={setSelectedStatuses}
        dataTestId={'statuses-dropdown'}
      />
    </div>
  )
}

Filters.propTypes = {
  stationIds: PropTypes.arrayOf(PropTypes.string),
  setSelectedStation: PropTypes.func,
  fuelGradesItems: PropTypes.arrayOf(PropTypes.string),
  fuelGrades: PropTypes.arrayOf(PropTypes.string),
  setSelectedGrades: PropTypes.func,
  statuses: PropTypes.arrayOf(PropTypes.string),
  setSelectedPeriod: PropTypes.func,
  period: PropTypes.shape({
    from: PropTypes.instanceOf(moment),
    to: PropTypes.instanceOf(moment),
  }),
}

Filters.defaultProps = {
  stationIds: [],
  fuelGradesItems: [],
  fuelGrades: [],
  statuses: [],
  period: null,
}

export { Filters }
